import type { RankedMode } from "./store";

// The two ranked modes, as the client names and routes them. The server's
// rules live in edge-server server.js (RANKED boxes); the copy here has to
// agree with them: a duel is first to 3 rounds on the Small arena, six worms
// play first to 20 on the Medium one, and every round is a 2:1 rectangle or a stadium.
export interface RankedModeMeta {
  mode: RankedMode;
  slug: string;        // /ranked/<slug>
  room: string;        // the matchmaking box's base room
  title: string;       // "1 vs 1"
  short: string;       // "1v1"
  players: number;
  rules: string;       // one line for the modal
  waitSecs: number;    // the box's window, for "usually under N seconds"
}

export const RANKED: Record<RankedMode, RankedModeMeta> = {
  duel: { mode: "duel", slug: "duel", room: "public:ranked-duel", title: "1 vs 1", short: "1v1", players: 2, rules: "First to 3 rounds · a rectangle or a stadium · Classic power-ups", waitSecs: 15 },
  ffa: { mode: "ffa", slug: "ffa", room: "public:ranked-ffa", title: "6 FFA", short: "6 FFA", players: 6, rules: "Six players · first to 20 points · a rectangle or a stadium · Classic power-ups", waitSecs: 30 },
};

export const RANKED_BY_SLUG: Record<string, RankedModeMeta> = { duel: RANKED.duel, ffa: RANKED.ffa };

// "Ranked 1 vs 1", for the end modal and the match cards.
export function rankedLabel(mode: RankedMode | string | null | undefined): string | null {
  return mode === "duel" || mode === "ffa" ? `Ranked ${RANKED[mode].title}` : null;
}

// A match id names its box: "public:ranked-duel#12" -> "duel".
export function rankedModeOfMatchId(matchId: string | null | undefined): RankedMode | null {
  const m = matchId ? /^public:ranked-(duel|ffa)#/.exec(matchId) : null;
  return m ? (m[1] as RankedMode) : null;
}
